import { render, staticRenderFns } from "./Applications.vue?vue&type=template&id=225c3e2a&"
import script from "./applications.js?vue&type=script&lang=js&"
export * from "./applications.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports